import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Form, reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Field } from 'redux-form'
import { Button,Confirm } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validations, validateCase as vCase } from 'core/validate'
import { CancelBillingContainer } from './styled'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { cancelBilling } from 'ducks/support'

const CancelBilling = (props) => {
    const { reset } = props

    const [showConfirm, setShowConfirm] = React.useState(false)

    const confirmSubmit = () =>{
      //chceck data
      if(props.valueForm.docNumber == undefined && props.valueForm.reasonDtgo == undefined){
      }
      else if(props.valueForm.docNumber != undefined && props.valueForm.reasonDtgo == undefined){
      }
      else if(props.valueForm.docNumber == undefined && props.valueForm.reasonDtgo != undefined){
      }
      else{
        setShowConfirm(true)
      }

    }

    const callAPI = () =>{
      setShowConfirm(false)
      props.cancelBilling(props.valueForm, reset)
    }
  
    return (
      <CancelBillingContainer>
        <Form>
          <div className='rowFields'>
            <Field 
              name='docNumber' 
              label='Billing Document Number' 
              type={type.text}
              component={FieldInput} />
          </div>
          <div className='rowFields'>
            <Field 
              name='reasonDtgo' 
              label='Reason DTGO' 
              type={type.textArea}
              component={FieldInput} />
               <Field 
              name='reasonVendor' 
              label='Reason Vendor' 
              type={type.textArea}
              component={FieldInput} />
          </div>
          <div className='btnContainer'>
            <Button
              type='button'
              content='Submit'
              color='blue'
              icon='paper plane outline'
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={() => confirmSubmit()}
            />
          </div>
        </Form>
        <Confirm
        size='tiny'
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={props.handleSubmit(()=> callAPI())}
      />
      </CancelBillingContainer>
    )
  }

  const mapStateToProps = (state) => {
    return ({
      user: state.authen.user,
      members: state.member.members,
      memberLoading: state.member.memberLoading,
      valueForm: getFormValues('CancelBillingForm')(state) || {},
    })
  }
  
  const mapDispatchToProps = {
    getHrmsMembers,
    cancelBilling,
    getAllMembers
  }
  
  const validate = (values) => {
    let errors = {}
    validations(values, 'docNumber', [vCase.require], errors)
    validations(values, 'reasonDtgo', [vCase.require], errors)
  
    return errors
  }
  
  const CancelBillingForm = reduxForm({
    form: 'CancelBillingForm',
    enableReinitialize: true,
    onSubmitFail: scrollToFirstValidateFailElement,
    validate,
  })(CancelBilling)
  
  export default connect(mapStateToProps, mapDispatchToProps)(CancelBillingForm)